'use client'

import { Link } from '@/shared/i18n'
import { Icon } from '@/shared/ui'

type Props = {
  href: string
  hasNewNotification: boolean
}

export const NotificationButton = ({ href, hasNewNotification }: Props) => {
  return (
    <Link href={href} className="relative" aria-label="알림">
      <Icon name="notification" size={24} strokeWidth={1.5} />
      {hasNewNotification && (
        <span className="absolute top-0 right-0 h-[5px] w-[5px] rounded-full bg-red-500" />
      )}
    </Link>
  )
}
